import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  CardContent,
  Typography,
  Chip,
  Divider,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import RoomIcon from "@mui/icons-material/Room";
import DevicesIcon from "@mui/icons-material/Devices";

// Labels mais amigáveis para os eventos
const EVENT_LABELS = {
  PENDING_ORDER: "Pedido criado",
  READY_TO_PICKUP: "Pronto para retirada",
  ACCEPT_ORDER: "Aceito pelo entregador",
  ARRIVED_ORDER: "Entregador chegou à loja",
  WITHDRAWN_ORDER: "Saiu para entrega",
  DELIVERY_ATTEMPT: "Tentativa de entrega",
  DELIVERED_ORDER: "Entregue com sucesso",
  CANCELED_ORDER: "Cancelado",
  FAILED_DELIVERY: "Falha na entrega",
  RETURN_ORDER: "Devolvido",
};

export default function OrderActivityModal({ open, onClose, activities }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            width: '50vw',
            maxWidth: '70vw',
            borderRadius: 2,
          },
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Atividades do Pedido
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Card sx={{ borderRadius: 2, boxShadow: 0 }}>
          <CardContent>
            <List sx={{ maxHeight: 400, overflow: "auto" }}>
              {activities.map((activity, idx) => (
                <React.Fragment key={activity._id}>
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Chip
                            label={
                              EVENT_LABELS[activity.eventType] ||
                              activity.eventType
                            }
                            variant="outlined"
                            color="primary"
                            size="small"
                          />
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <CalendarTodayIcon fontSize="small" />
                            <Typography variant="caption">
                              {new Date(
                                activity.timestamp
                              ).toLocaleString()}
                            </Typography>
                          </Box>
                        </Box>
                      }
                      secondary={
                        <Box mt={1}>
                          {activity.description && (
                            <Typography variant="body2">
                              {activity.description}
                            </Typography>
                          )}

                          <Box
                            mt={1}
                            display="flex"
                            flexWrap="wrap"
                            gap={2}
                            color="text.secondary"
                          >
                            <Box display="flex" alignItems="center" gap={0.5}>
                              <PersonIcon fontSize="small" />
                              <Typography variant="caption">
                                {activity.user?.name ||
                                  "Usuário desconhecido"}
                              </Typography>
                            </Box>

                            <Box display="flex" alignItems="center" gap={0.5}>
                              <DevicesIcon fontSize="small" />
                              <Typography variant="caption">
                                {activity.platform}
                              </Typography>
                            </Box>

                            {activity.location?.latitude &&
                              activity.location?.longitude && (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={0.5}
                                >
                                  <RoomIcon fontSize="small" />
                                  <Typography variant="caption">
                                    {activity.location.latitude.toFixed(4)},{" "}
                                    {activity.location.longitude.toFixed(4)}
                                  </Typography>
                                </Box>
                              )}
                          </Box>
                        </Box>
                      }
                    />
                  </ListItem>

                  {idx < activities.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
            </List>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
